import React from 'react'
import { object } from 'prop-types'
import ProfileHeader from '@/component/Primitive/ProfileHeader/new'
import ProfileLink from '@/component/Primitive/ProfileHeader/component/ProfileLink'
import changeFileExtension from '@/lib/filename-extension-modifier'
import MagazineCTA from '@/component/Primitive/MagazineCTA'
import styles from './CompanyProfile.module.scss'
import Advert from '@/component/Primitive/Advert'
import SimpleList from '@/component/Primitive/SimpleList'

const CompanyProfile = ({ pageData, latestMagazineIssue, section }) => {
  const { company } = pageData

  const formattedCompany = {
    heading: company.name,
    subHeading: company.shortDescription,
    description: company.description,
    meta: company.aiMeta,
    src: company.images.thumbnail_1x1_576[0].url,
    srcSet: [220, 576, 720, 900].map((size) => {
      return {
        width: size,
        src: changeFileExtension(
          company.images[`thumbnail_1x1_${size}`][0].url,
          'webp'
        )
      }
    }),
    imageRatio: 1
  }

  const magazineWidgetProps = {
    to: '/magazine',
    as: `/magazine/${latestMagazineIssue?.slug}`,
    title: 'Read the latest Digital Magazine today!',
    imageUrl: latestMagazineIssue?.images?.cover_321x446_150?.[0]?.url,
    variation: 'large',
    className: styles.CompanyMagazineCTA,
    classNames: {
      title: styles.CompanyMagazineCTATitle,
      button: styles.CompanyMagazineCTAButton
    }
  }

  const advertProps = {
    suffix: null,
    slotName: null,
    size: '300x250',
    keyValueTargeting: {},
    alignment: 'right',
    article: null,
    section,
    className: styles.CompanyAdvert
  }

  const formattedArticles = company.latestContent?.map((article) => ({
    content: article.headline,
    href: article.fullUrlPath,
    tags: article.category ? [{ title: article.category }] : null
  }))
  const listProps = {
    listData: formattedArticles,
    titlePrimary: 'Latest',
    titleSecondary: 'Content',
    className: styles.CompanySimpleList
  }

  return (
    <ProfileHeader {...formattedCompany}>
      {company.linkedinId && (
        <ProfileLink
          url={`https://www.linkedin.com/company/${company.linkedinId}`}
          type="linkedin"
          className={styles.CompanyLink}
        >
          Follow on LinkedIn
        </ProfileLink>
      )}
      {company.emailAddress && (
        <ProfileLink
          url={`mailto:${company.emailAddress}`}
          type="email"
          className={styles.CompanyLink}
        >
          Contact Partner
        </ProfileLink>
      )}
      {company.website && (
        <ProfileLink
          url={company.website}
          type="globe"
          className={styles.CompanyLink}
        >
          Visit Partner Website
        </ProfileLink>
      )}
      {latestMagazineIssue && <MagazineCTA {...magazineWidgetProps} />}
      <Advert {...advertProps} />
      {company.latestContent && company.latestContent?.length ? (
        <SimpleList {...listProps} />
      ) : null}
    </ProfileHeader>
  )
}

CompanyProfile.propTypes = {
  pageData: object,
  latestMagazineIssue: object,
  section: object
}

export default CompanyProfile
